export const fieldKeys = [
  'name',
  'timezone',
  'currency_format',
  'balance_format',
  'service_auto_rate_format',
  'services_search',
  'service_name_format',
  'favorite_services',
  'ticket_system',
  'ticket_categories',
  'ticket_per_user',
  'registration_page',
  'email_confirmation',
  'terms_checkbox',
  'forgot_password',
  'minimum_drip_feed_interval',
  'cpf_mode',
  'google_verification_code',
  'custom_header',
  'custom_footer',
];
